import React from 'react'
import { modalActions } from 'store/modal'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import DiaryView from '../components/DiaryView'
import { duplicateItem, mediaActions, diaryActions } from '../modules/Diary'
import { instrumentActions, metadataActions } from '../../../modules/Instrument'
import { downloadInstrument } from '../../../../InstrumentsPage/modules/Instruments'

const mapDispatchToProps = {
  duplicateItem,
  ...diaryActions,
  ...mediaActions,
  ...instrumentActions,
  ...metadataActions,
  ...modalActions,
  downloadInstrument,
}

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const isCreateDiary = state.location?.pathname?.includes('/instruments/creatediary')
  const path = state.location?.pathname === '/instruments/creatediary' ? 'create' : 'edit'
  const { instrumentReducer, diaryEditor, loading, user, study } = state
  const instrument = instrumentReducer?.instrument || {}
  const { type, title, url } = instrument
  const diary = diaryEditor?.diary

  return {
    id: diary?.id,
    type,
    url,
    instrumentTitle: title,
    diary,
    article: diaryEditor?.article,
    isLoading: loading?.general,
    questionNumbers: diary?.questionNumbers,
    wordCount: diaryEditor?.wordCount,
    version: instrument.metadata?.version ?? 1,
    path,
    studyID: study?.currentStudy?.id,
    siteID: getBaseSiteIdFromStudy(study),
    errors: diaryEditor?.diaryErrors,
    isCreateDiary,
    studyVersionID,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return props.isLoading ? <Loader active /> : <DiaryView {...props} />
})
